<template>
    <div class="setting">
        <div class="tableConBox">
            <div class="tableTem">
                <div class="HSpace1"></div>
                <div class="setBox">
                    <div class="HSpace1"></div>
                    <div class="setItemBox">
                        <div class="title">系统设置</div>
                         <!-- <div class="setItem clearfix">
                            <span class="left itemName">是否开启店员宝现金支付：</span>
                            <el-radio class="radio left itemRadio" v-model="clerkCashSales" label="ON" >是</el-radio>
                            <el-radio class="radio left itemRadio" v-model="clerkCashSales" label="OFF">否</el-radio>
                            <span class="left tip">（适应于店员宝下单不支持现金支付的网吧）</span>
                        </div> -->
                        <!-- <div class="setItem clearfix">
                            <span class="left itemName">是否开启库存限制开关：</span>
                            <el-radio class="radio left itemRadio" v-model="stockLimitSales" label="ON">是</el-radio>
                            <el-radio class="radio left itemRadio" v-model="stockLimitSales" label="OFF">否</el-radio>
                            <span class="left tip">（适应于不需要入库操作的网吧）</span>
                        </div>  -->
                        <div class="setItem clearfix">
                            <span class="left itemName">是否开启系统网费开关：</span>
                            <el-radio class="radio left itemRadio" v-model="customSwitch" label="ON">是</el-radio>
                            <el-radio class="radio left itemRadio" v-model="customSwitch" label="OFF">否</el-radio>
                            <span class="left tip">（推荐网吧开启）</span>
                        </div>
                        <!-- <div class="setItem clearfix">
                            <span class="left itemName">是否开启店员宝会员登录开关：</span>
                            <el-radio class="radio left itemRadio" v-model="clerkMember" label="ON">是</el-radio>
                            <el-radio class="radio left itemRadio" v-model="clerkMember" label="OFF">否</el-radio>
                            <span class="left tip">（推荐开启，便于会员管理）</span>
                        </div> -->
                        <!-- <div class="setItem clearfix">
                            <span class="left itemName">收款方式：</span>
                            <span class="left item-model" @click="codes('THIRD_PARTY')"><div :class="{show:!isCASHIERBtn}"></div>银行通道收款模式</span>
                            <span class="left item-model" @click="codes('CASHIER')"><div :class="{show:isCASHIERBtn}"></div>微信/支付宝收款码模式</span>
                            <span class="left tip">（请谨慎操作，需在我方平台服务人员指导下进行此操作）</span>
                        </div> -->
                        <div class="setItem clearfix">
                            <span class="left itemName">是否开启退单授权密码验证：</span>
                            <el-radio class="radio left itemRadio" v-model="refundSwitch" label="ON">是</el-radio>
                            <el-radio class="radio left itemRadio" v-model="refundSwitch" label="OFF">否</el-radio>
                        </div>
                        <div class="setItem clearfix" style="height:36px;line-height:36px;">
                            <span class="left itemName">新增会员派发优惠券：</span>
                            <el-radio class="radio left itemRadio" v-model="couponSwitch" label="ON">是</el-radio>
                            <el-radio class="radio left itemRadio" v-model="couponSwitch" label="OFF">否</el-radio>
                            <el-select v-model="couponModel" v-if="couponSwitch=='ON'" style="margin-left:10px;" class="left">
                                <el-option
                                    v-for="item in couponList"
                                    :key="item.id"
                                    :label="item.title"
                                    :value="JSON.stringify(item)">
                                </el-option>
                                <li v-if="couponListMoreBtn" @click="print()" style="color:#999;padding:10px 0;text-align:center;cursor:pointer;"><span>更多优惠券...</span></li>
                            </el-select>
                            <p v-if="couponSwitch=='ON'" @click="configCoupon" class="left" style="color:#fff;text-align:center;cursor:pointer;margin-left:20px;background-color: #3068ff;width:80px;border-radius:20px;">提交</p>
                            <!-- <span class="left tip">（请谨慎操作，需在我方平台服务人员指导下进行此操作）</span> -->
                        </div>
                        
                    </div>
                    <div class="setItemBox">
                        <div class="title">店铺设置</div>
                        <div class="setItem_1 clearfix">
                            <div class="left itemName">店铺名称：</div>
                            <input class="left" type="text" v-model="newStore.name" placeholder="请输入店铺名">
                        </div>
                        <div class="setItem_1 clearfix">
                            <div class="left itemName">店铺类型：</div>
                            <el-select v-model="newStore.typeId" placeholder="请选择店铺类型" class="left">
                                <el-option
                                    v-for="item in storeType"
                                    :key="item.code"
                                    :label="item.name"
                                    :value="item.code">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="setItem_1 clearfix">
                            <div class="left itemName">店铺地址：</div>
                            <input class="left" type="text" v-model="newStore.addr" placeholder="请输入地址">
                        </div>
                        <div class="btnGroup">
                            <button type="button" @click="saveStore">保存</button>
                        </div>
                    </div>

                    <div class="setItemBox">
                        <div class="title">呼叫设置</div>
                        <div class="setItem_1 clearfix">
                            <div class="left itemName">呼叫热栏信息标题：</div>
                            <input class="left" type="text" style="width:300px;" v-model="hotTitle" placeholder="请输入...(如近期热销、最近更新、等等...)">
                        </div>
                        <div class="setItem_1 clearfix">
                            <div class="left itemName">呼叫滚动信息标题：</div>
                            <input class="left" type="text" style="width:300px;" v-model="rollTitle" placeholder="（默认为打赏排名）请输入...(如网吧公告，等...)">
                            <span style="color:red;font-size:12px">*修改为打赏排名将展示打赏排名信息</span>
                        </div>
                        <div class="setItem_1 clearfix desc">
                            <div class="left itemName">呼叫滚动信息：</div>
                            <textarea name="" v-model="rollNotice" id="" cols="30" rows="10" placeholder="请输入呼叫滚动信息...">

                            </textarea>
                        </div>
                        <div class="setItem_1 clearfix desc">
                            <div class="left itemName">店铺简介：</div>
                            <textarea name="" v-model="summary" id="" cols="30" rows="10" placeholder="请输入店铺简介...">

                            </textarea>
                            <!-- <input class="left" type="text" style="width:300px;" v-model="summary" placeholder="请输入店铺简介..."> -->
                        </div>
                        <div class="setItem_1 clearfix logo">
                            <div class="left itemName">店铺logo：</div>
                            <img v-if="logoUrl" :src="logoUrl" alt="">
                            <input type="file" ref="logoUrl" accept=".png,.jpg,.jpeg" @change="coverImg($event,'logo')" class="pcImgFile" title="选择图片">
                            <span style="color:red;font-size:12px">*请裁剪为正方形</span>
                        </div>
                        <div class="setItem_1 clearfix logo">
                            <div class="left itemName">店铺二维码：</div>
                            <img v-if="storeQrCode" :src="storeQrCode" alt="">
                            <input type="file" ref="storeQrCode" accept=".png,.jpg,.jpeg" @change="coverImg($event,'storeQrCode')" class="pcImgFile" title="选择图片">
                            <span style="color:red;font-size:12px">*店铺联系人二维码(此二维码将展示在呼叫客户端)</span>
                        </div>
                        <div class="btnGroup">
                            <button type="button" @click="saveCallInfo">保存</button>
                        </div>
                    </div>

                    <div class="setItemBox">
                        <div class="title">会员充值设置</div>
                        <div class="setItem_1 clearfix">
                            <div class="left itemName">会员充值最低限额：</div>
                            <input class="left" type="text" style="width:100px;" v-model="limitRechargeMoney" placeholder="请输入金额">
                        </div>
                        <div class="btnGroup">
                            <button type="button" @click="saveLimit">保存</button>
                        </div>
                    </div>

                    <!-- <div class="setItemBox">
                        <div class="title">提成占比设置</div>
                        <div class="setItem_1 clearfix">
                            <div class="left itemName">原有提成占比：</div>
                            <input class="left" type="number" min="0" max="100" style="width:100px;" v-model="globalRate" placeholder="请输入">%
                        </div>
                        <div class="btnGroup">
                            <button type="button" @click="saveGlobalRate">保存</button>
                        </div>
                    </div> -->

                    <!--  -->
                    <div class="setItemBox">
                        <div class="title">店铺是否开启配送员</div>
                        <div class="setItem_1 clearfix">
                            <el-radio class="radio left itemRadio" v-model="deliveryEnabled" :label="true">是</el-radio>
                            <el-radio class="radio left itemRadio"  v-model="deliveryEnabled" :label="false">否</el-radio>
                        </div>
                        <div class="setItem_1 clearfix" v-if="deliveryEnabled">
                            <div class="left itemName">原有提成的占比：</div>
                            <input class="left" type="number" min="0" max="100" style="width:100px;" v-model="globalRate" placeholder="请输入">%
                        </div>
                        <div class="btnGroup">
                            <button type="button" @click="saveDelivery">保存</button>
                        </div>
                    </div>
                    <!--  -->
                    <div class="setItemBox">
                        <div class="title">客户端是否开启会员支付</div>
                        <div class="setItem_1 clearfix">
                            <el-radio class="radio left itemRadio" v-model="memberEnabled" :label="true">是</el-radio>
                            <el-radio class="radio left itemRadio"  v-model="memberEnabled" :label="false">否</el-radio>
                        </div>
                        <div class="btnGroup">
                            <button type="button" @click="saveMem">保存</button>
                        </div>
                    </div>
                    

                    <div class="setItemBox">
                        <div class="title">授权密码设置</div>
                        <div class="setItem_1 clearfix">
                            <div class="left itemName">密码</div>
                            <input class="left" type="password" style="width:100px;" v-model="discountPwd" placeholder="请输入密码">
                        </div>
                        <div class="btnGroup">
                            <button type="button" @click="savePwd">保存</button>
                        </div>
                    </div>
                    <!--  -->
                    <div class="setItemBox">
                        <div class="title">是否允许PC点单</div>
                        <div class="setItem_1 clearfix">
                            <el-radio class="radio left itemRadio" v-model="pcOrderEnabled" label="ON">是</el-radio>
                            <el-radio class="radio left itemRadio"  v-model="pcOrderEnabled" label="OFF">否</el-radio>
                        </div>
                        <div class="btnGroup">
                            <button type="button" @click="savePcOrderEnabled">保存</button>
                        </div>
                    </div>
                    <!--  -->
                    <!-- <div class="setItemBox">
                        <div class="title">是否开启小票自动打印</div>
                        <div class="setItem_1 clearfix">
                            <el-radio class="radio left itemRadio" v-model="autoPrintEnabled" label="ON">是</el-radio>
                            <el-radio class="radio left itemRadio"  v-model="autoPrintEnabled" label="OFF">否</el-radio>
                        </div>
                        <div class="btnGroup">
                            <button type="button" @click="saveAutoPrint">保存</button>
                        </div>
                    </div> -->
                    <!--  -->
                    <div class="setItemBox">
                        <div class="title">是否开启音频设备选择</div>
                        <div class="setItem_1 clearfix">
                            <el-radio class="radio left itemRadio" v-model="voiceEnabled" label="ON">是</el-radio>
                            <el-radio class="radio left itemRadio"  v-model="voiceEnabled" label="OFF">否</el-radio>
                        </div>
                        <div class="btnGroup">
                            <button type="button" @click="saveIsOpenVoiceSel">保存</button>
                        </div>
                    </div>
                    <!--  -->
                    <div class="setItemBox">
                        <div class="title">是否开启租赁设备归还语音播报</div>
                        <div class="setItem_1 clearfix">
                            <el-radio class="radio left itemRadio" v-model="returnCallEnabled" :label="true">是</el-radio>
                            <el-radio class="radio left itemRadio"  v-model="returnCallEnabled" :label="false">否</el-radio>
                        </div>
                        <div class="btnGroup">
                            <button type="button" @click="saveReturnCallEnabled">保存</button>
                        </div>
                    </div>
                    <div class="setItemBox">
                        <div class="title">是否开启交班预打印小票</div>
                        <div class="setItem_1 clearfix">
                            <el-radio class="radio left itemRadio" v-model="isOpenPrevPrint" label="ON">是</el-radio>
                            <el-radio class="radio left itemRadio"  v-model="isOpenPrevPrint" label="OFF">否</el-radio>
                        </div>
                        <div class="btnGroup">
                            <button type="button" @click="saveIsOpenPrevPrint">保存</button>
                        </div>
                    </div>
                    <div class="setItemBox">
                        <div class="title">是否允许收银端下架商品</div>
                        <div class="setItem_1 clearfix">
                            <el-radio class="radio left itemRadio" v-model="allowProductCancelSale" :label="true">是</el-radio>
                            <el-radio class="radio left itemRadio"  v-model="allowProductCancelSale" :label="false">否</el-radio>
                        </div>
                        <div class="btnGroup">
                            <button type="button" @click="saveAllowProductCancelSale">保存</button>
                        </div>
                    </div>
                    <div class="setItemBox">
                        <div class="title">厨房打印机IP设置<button class="add-more" @click="printEr.push({id:'',name:'',ipAddress:'',port:''})">添加更多打印机</button></div>
                        <div class="setItem_1 clearfix" v-for="(item,index) in printEr" :key="index">
                            <div class="left itemName">打印机名字:</div>
                            <input class="left" type="text" style="width:120px;text-align:center;padding-left:0;" v-model="item.name" placeholder="自定义打印机名字">
                            <div class="left itemName">&nbsp;IP地址:</div>
                            <input class="left" type="text" style="width:120px;text-align:center;padding-left:0;" v-model="item.ipAddress" placeholder="请输入IP地址">
                            <div class="left itemName">&nbsp;端口号:</div>
                            <input class="left" type="text" style="width:120px;text-align:center;padding-left:0;" v-model="item.port" placeholder="请输入端口号">
                            <button style="margin-left:15px;" @click="savePrintEr(item)">保存</button>
                            <button @click="delPrintEr(item,index)">删除</button>
                        </div>
                        <!-- <div class="btnGroup">
                            <button type="button" @click="savePrintSet">保存</button>
                        </div> -->
                    </div>
                    <div class="setItemBox">
                        <div class="title">点单备注信息设置<button class="add-more" @click="notesArr.push({id:'',message:''})">添加更多备注</button></div>
                        <div class="setItem_1 clearfix" v-for="(item,index) in notesArr" :key="index">
                            <div class="left itemName">内容:</div>
                            <input class="left" type="text" style="width:350px;text-align:left;padding-left:0;" v-model="item.message" placeholder="请填写备注内容...">
                            <button style="margin-left:15px;" @click="saveNotes(item)">保存</button>
                            <button @click="delNotes(item)">删除</button>
                        </div>
                        <!-- <div class="btnGroup">
                            <button type="button" @click="savePrintSet">保存</button>
                        </div> -->
                    </div>
                    <div class="setItemBox">
                        <div class="title">机位预订时间设置<button class="add-more" @click="timeArr.push({id:'',m:''})">添加更多时间</button></div>
                        <div class="setItem_1 clearfix">
                            是否开启店员宝机位预订
                            <el-radio class="radio itemRadio" v-model="dateOpen" :label="true">是</el-radio>
                            <el-radio class="radio itemRadio"  v-model="dateOpen" :label="false">否</el-radio>
                        </div>
                        <div class="setItem_1 clearfix">
                            是否开启下机播报
                            <el-radio class="radio itemRadio" v-model="voiceNotify" :label="true">是</el-radio>
                            <el-radio class="radio itemRadio"  v-model="voiceNotify" :label="false">否</el-radio>
                        </div>
                        <!--  -->
                        <!-- <div class="setItem_1 clearfix">
                            下机播报音频播放端
                            <el-radio-group v-model="posCallEnabled" @change="changePosCallEnabled">
                                <el-radio class="radio itemRadio"  :label="'ON'">POS收银端</el-radio>
                                <el-radio class="radio itemRadio"  :label="'OFF'">呼叫服务端</el-radio>
                            </el-radio-group>
                        </div> -->
                        <!--  -->
                        <div class="setItem_1 clearfix" v-if="voiceNotify">
                            <input class="left" type="text" style="width:200px;" v-model="frontMessage" placeholder="自定义内容...">
                            <div class="left itemName">**号机已下机</div>
                            <input class="left" type="text" style="width:200px;" v-model="backMessage" placeholder="自定义内容...">
                        </div>
                        <div class="setItem_1 clearfix" v-for="(item,index) in timeArr" :key="index">
                            <div class="left itemName">时间（分钟）:</div>
                            <input class="left" type="number" style="width:200px;" v-model="item.m" placeholder="请填写时间（分钟）...">
                            <button @click="delTime(index)">删除</button>
                        </div>
                        <div class="btnGroup">
                            <button type="button" @click="saveTime">保存</button>
                        </div>
                    </div>
                    <!--  -->
                </div>
            </div>
        </div>
        <el-dialog
            :title="'验证码'"
            class="codes"
            :visible.sync="codeBtn"
            @close='closeDialog'
            v-loading.body="infoload"
            size="tiny">
            <div style="color:red;margin-top:10px;font-size:12px;text-align:center;position:absolute;top:8px;left:7em;" v-if="!isSendCodeBtn">
                <span >验证码已发送到老板手机号</span>
            </div>
            <div class="inners">
                <input type="text" placeholder="请输入验证码" v-model="code">
                <span class="sendcode" @click="getCode" v-if="isSendCodeBtn">发送验证码</span>
                <span class="times" v-if="!isSendCodeBtn" v-text="isSendCodeTimer+'s'"></span>
            </div>
            <span slot="footer" class="dialog-footer">
                <button type="button" @click="codeBtn=false;code='';initBtn4 = true;isCancle=true" class="cancel">取消</button>
                <button type="button" @click="codeFn" class="save">保存</button>
            </span>
        </el-dialog>
        <img-crop v-if="showCrop" :oldImg="oldImgBase64" :curCropW="curCropW" :curCropH="curCropH" :curStoreId="curStoreId" @closeImgCrop="showCrop=false" @getCropImgBase="getCropImgBase"></img-crop>
    </div>
</template>

<script type="text/javascript">
    import imgCrop from '@/components/imgCrop/imgCrop.vue';
    import {API_BASE_URL} from "@/urlConfig/index.js";
    export default{
        components: {imgCrop},
        props: ['curStoreId','storeData','pageSize'],
    	data () {
    		return {
                returnCallEnabled:true,
                posCallEnabled:"ON",
                pcOrderEnabled:"OFF",
                voiceEnabled:"OFF",
                autoPrintEnabled:"OFF",
                globalRate:"",
                deliveryEnabled:false,
                frontMessage:"工作人员请注意,",
                backMessage:",请及时清理桌面保持卫生",
                // 
                voiceNotify:false,
                dateOpen:false,
                timeArr:[],
                //
                allowProductCancelSale:true,
                upLoadImgType:"logo",
                summary:'',
                hotTitle:"",
                rollTitle:'',
                rollNotice:"",
                storeQrCode:"",
                logoUrl:"",
                showCrop: false, // 控制图片裁剪显示隐藏

                refundSwitch:"",
                isOpenPrevPrint:"OFF",
                notesArr:[{
                    id:'',
                    message:''
                }],
                printEr:[{
                    id:"",
                    name:"",
                    ipAddress:"",
                    port:""
                }],
                discountPwd:"",
                limitRechargeMoney:0,
                storeType: [],
                newStore: {
                    "name": "", // 店铺名称
                    "typeId": "", // 店铺类型id
                    "addr": "", // 店铺地址
                    "referralCode": "" // 邀请码
                },
                initBtn1:true,
                clerkCashSales: '', // 店员宝现金支付开关
                initBtn2:true,
                stockLimitSales: '', // 库存开关
                initBtn3:true,
                initBtn9:true,
                customSwitch:'',//系统网费
                initBtn4:true,
                // clerkMember:'',//店员宝会员
                payModeSwitch:'',//收款方式
                infoload: false, // loading
                codeBtn:false,
                isCancle:false,
                memberEnabled:false,
                code:'',//验证码
                isSendCodeBtn:true,
                isSendCodeTimer:59,

                isCASHIERBtn:false,



                couponSwitch:'OFF',//是否给新增会员派发优惠券
                initBtn5:true,
                couponModel:'',
                curCouponData:{id:''},
                couponListMoreBtn:false,
                couponList:[],
                curCouponPage:0,
                coverImgMaxSize: 5*1024*1024, // 图片最大字节数
                oldImgBase64: '', // 原图base64
                showCrop: false, // 控制图片裁剪显示隐藏
                curCropW: 600, // 裁剪宽度
                curCropH: 600, // 裁剪高度

    		}
    	},
        watch: {
            refundSwitch(val){
                console.log(val)
                if(this.initBtn9 ){
                    this.initBtn9 = false;
                    return;
                }
                let refundSwitch;
                if(val=='ON'){
                   refundSwitch = true; 
                }else if(val=='OFF'){
                   refundSwitch = false; 
                }
               this.$http.get(`/stores/refund-switch?refundSwitch=`+refundSwitch+'&storeId='+this.curStoreId).then((res)=>{
                    
               }) 
            },
            couponSwitch(val){
                if(this.initBtn5 ){
                    this.initBtn5 = false;
                    return;
                }
                if(val=='ON'){
                   this.curCouponPage = 0; 
                   
                }else if(val=='OFF'){
                    let body= {
                        storeId: this.curStoreId,
                        giveCouponId: ''
                    }
                    this.$http.post('stores-config',body).then((res)=>{
                        this.curCouponData = {};
                        this.couponModel = '';
                    })
                }
            },
            couponModel( val ) {
                this.curCouponData = JSON.parse(val);
            },
            clerkCashSales ( val ) {
                let status =false;
                if(val == "OFF"){
                     status =false;
                }else if(val == "ON"){
                     status = true;
                }

                if(this.initBtn1){
                    this.initBtn1 = false;
                    return;
                }
                this.$http.put('stores/'+this.curStoreId+'/cash-switch?switch='+status).then((res)=>{
                }).catch(()=>{

                })
            },
            stockLimitSales ( val ) {
                let status =false;
                if(val == "OFF"){
                    status =false;
                }else if(val == "ON"){
                     status = true;
                }
                if(this.initBtn2 ){
                    this.initBtn2 = false;
                    return;
                }
                this.$http.put('stores/'+this.curStoreId+'/stock-switch?switch='+status).then((res)=>{
                }).catch(()=>{

                })
            },
            customSwitch( val ){
                let status =false;
                if(val == "OFF"){
                    status =false;
                }else if(val == "ON"){
                     status = true;
                }
                if(this.initBtn3 ){
                    this.initBtn3 = false;
                    return;
                }
                this.$http.put('stores/'+this.curStoreId+'/product-switch?switch='+status).then((res)=>{
                }).catch(()=>{})
            },
            // clerkMember(val){
            //     let status =false;
            //     if(val == "OFF"){
            //         status =false;
            //     }else if(val == "ON"){
            //          status = true;
            //     }
            //     if(this.initBtn4 ){
            //         this.initBtn4 = false;
            //         return;
            //     }
            //     this.$http.put('stores/'+this.curStoreId+'/clerkMember-switch?switch='+status).then((res)=>{
            //     }).catch(()=>{})
            // }
        },
        methods: {
            saveReturnCallEnabled(){
                this.$http({
                    url:`${API_BASE_URL}v1/call/return/enabled`,
                    method:"POST",
                    data:{
                        storeId:this.curStoreId,
                        returnCallEnabled:this.returnCallEnabled?true:false
                    }
                }).then(res=>{
                    this.$message({
                        message: "操作成功",
                        customClass: 'success'
                    });
                })
            },
            // 
            changePosCallEnabled(){
                console.log("posCallEnabled",this.posCallEnabled);
                this.$http({
                    url:"pos/call",
                    method:"POST",
                    data:{
                        storeId:this.curStoreId,
                        posCallEnabled:this.posCallEnabled=="ON"?true:false
                    }
                }).then(res=>{

                })
            },
            // 
            saveAutoPrint(){
                this.$http({
                    url:"auto/print",
                    method:"POST",
                    data:{
                        storeId:this.curStoreId,
                        autoPrintEnabled:this.autoPrintEnabled=="ON"?true:false
                    }
                }).then(res=>{
                    this.$message({
                        message: res.data,
                        customClass: 'success'
                    });
                });
            },
            // 
            saveGlobalRate(){
                if(!/^(0|[1-9][0-9]{0,9})$/.test(this.globalRate)){
                    this.$message({
                        message: "请正确填写提成比例，比例为正整数",
                        customClass: 'error'
                    });
                    return;
                }
                if(this.globalRate < 0 || this.globalRate > 100){
                    this.$message({
                        message: "请正确填写提成比例，比例为正整数",
                        customClass: 'error'
                    });
                    return;
                }
                this.$http({
                    url:"global/rate",
                    method:"POST",
                    data:{
                        storeId:this.curStoreId,
                        globalRate:(this.globalRate / 100).toFixed(2)
                    }
                }).then(res=>{
                    this.$message({
                        message: "操作成功",
                        customClass: 'success'
                    });
                });
            },
            // 
            saveMem(){
                this.$http({
                    url:"member/enabled",
                    method:"POST",
                    data:{
                        storeId:this.curStoreId,
                        memberEnabled:this.memberEnabled
                    }
                }).then(res=>{
                    this.$message({
                        message: "操作成功",
                        customClass: 'success'
                    });
                });
            },
            saveDelivery(){
                this.$http({
                    url:"delivery",
                    method:"POST",
                    data:{
                        storeId:this.curStoreId,
                        deliveryEnabled:this.deliveryEnabled
                    }
                }).then(res=>{
                    this.$message({
                        message: "操作成功",
                        customClass: 'success'
                    });
                    if(this.deliveryEnabled){
                        this.saveGlobalRate();
                    }
                });
            },
            // 
            saveAllowProductCancelSale(){
                this.$http({
                    url:"allowProductCancelSale",
                    method:"POST",
                    data:{
                        storeId:this.curStoreId,
                        allowProductCancelSale:this.allowProductCancelSale
                    }
                }).then(res=>{
                    this.$message({
                        message: "操作成功",
                        customClass: 'success'
                    });
                });
            },
            saveCallInfo(){
                this.$http({
                    url:"setup-call",
                    method:"POST",
                    data:{
                        storeId:this.curStoreId,
                        logo:this.logoUrl,
                        summary:this.summary,
                        title:this.hotTitle,
                        notice:this.rollNotice,
                        // qr_code:this.storeQrCode,
                        storeCodeImage:this.storeQrCode,
                        net_title:this.rollTitle,
                    }
                }).then(res=>{
                    this.$message({
                        message: res.data,
                        customClass: 'success'
                    });
                });
            },
            // 获得裁剪后图片base64
            getCropImgBase: function ( imgUrl )　{
                if(this.upLoadImgType == "logo"){
                    this.logoUrl = imgUrl;
                }else{
                    this.storeQrCode = imgUrl;
                }
            },
            coverImg: function ( e,type ) {
                this.upLoadImgType = type;
                let reader = new FileReader();
                let that = this;
                let fileObj = e.target.files[0];

                if( e.target.files.length == 0 ) {
                    return false;
                }

                // 判断图片大小
                if( fileObj.size > this.coverImgMaxSize ) {
                    this.errorMsg = '上传图片的大小不能超过5MB';
                    this.openErrorTip = true;
                    this.$message({
                        message: '上传图片的大小不能超过5MB',
                        customClass: 'error'
                    })
                    return false;
                }

                reader.onload = (function (file) {
                    return function (e) {
                        let that2 = this; // 缓存当前this
                        let img = new Image();
                        img.src= this.result;
                        img.onload=function(){
                            let imgBase64 = that2.result; //获得图片的base64的数据
                            // 判断是否是移动端设备
                            let sUserAgent = navigator.userAgent.toLowerCase();
                            let bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
                            let bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
                            let bIsMidp = sUserAgent.match(/midp/i) == "midp";
                            let bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
                            let bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
                            let bIsAndroid = sUserAgent.match(/android/i) == "android";
                            let bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
                            let bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
                            if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
                                that.mobileUploadImg(imgBase64);
                            } else {
                                that.oldImgBase64 = imgBase64;
                                that.showCrop = true;
                            }
                        };
                        $('.pcImgFile').val('');
                        $('.mobileImgFile').val('');
                    };
                })(e.target.files[0]);
                reader.readAsDataURL(e.target.files[0]);
            },
            // 
            savePcOrderEnabled(){
                this.$http({
                    url:"pc/order",
                    method:"POST",
                    data:{
                        storeId:this.curStoreId,
                        pcOrderEnabled:this.pcOrderEnabled=="ON"?true:false
                    }
                }).then(res=>{
                    this.$message({
                        message: res.data,
                        customClass: 'success'
                    });
                });
            },
            // 
            saveIsOpenVoiceSel(){
                this.$http({
                    url:"voice",
                    method:"POST",
                    data:{
                        storeId:this.curStoreId,
                        voiceEnabled:this.voiceEnabled=="ON"?true:false
                    }
                }).then(res=>{
                    this.$message({
                        message: res.data,
                        customClass: 'success'
                    });
                });
            },
            // 
            saveIsOpenPrevPrint(){
                this.$http({
                    url:"pre-enabled",
                    method:"POST",
                    data:{
                        storeId:this.curStoreId,
                        preEnabled:this.isOpenPrevPrint=="ON"?true:false
                    }
                }).then(res=>{
                    this.$message({
                        message: res.data,
                        customClass: 'success'
                    });
                });
            },
            delPrintEr(item,index){
                if(!item.id){
                    let printEr = JSON.parse(JSON.stringify(this.printEr));
                    printEr.splice(index,1);
                    this.printEr = printEr;
                    return;
                }
                this.$http({
                    url:"delete-ip",
                    method:"POST",
                    data:{
                        id:item.id
                    }
                }).then(res=>{
                    console.log(res);
                    if(res.data.code == 200){
                        this.$message({
                            message: res.data.msg,
                            customClass: 'success'
                        });
                        this.getPrintIpInfo();
                        return;
                    }else{
                        this.$message({
                            message: res.data.msg,
                            customClass: 'error'
                        });
                        return;
                    }
                });
            },
            saveTime(){
                let timeArr = JSON.parse(JSON.stringify(this.timeArr));
                console.log(timeArr);
                if(timeArr && Array.isArray(timeArr)){
                    let minutes = []; 
                    let flag= false;
                    timeArr.forEach(it=>{
                        if(it.m < 0 || it.m == 0){
                            flag = true;
                        }
                        minutes.push(it.m);
                    });
                    if(flag){
                        this.$message({
                            message: "分钟数填写错误",
                            customClass: 'error'
                        });
                        return;
                    }
                    let message = "";
                    if(this.voiceNotify){
                        if(!String(this.frontMessage).trim() || !String(this.backMessage).trim()){
                            this.$message({
                                message: "请正确填写下机播报内容",
                                customClass: 'error'
                            });
                            return;
                        }
                        let frontMessage = this.frontMessage.replace(/，/g,",");
                        let backMessage = this.backMessage.replace(/，/g,",");
                        message = `${frontMessage}**号机已下机${backMessage}`;
                    }
                    
                    this.$http({
                        url:"store-region-config",
                        method:"POST",
                        data:{
                            storeId:this.curStoreId,
                            voiceNotify:this.voiceNotify,
                            dateOpen:this.dateOpen,
                            message,
                            minutes:JSON.stringify(minutes)
                        }
                    }).then(res=>{
                        console.log(res);
                        this.$message({
                            message: "操作成功",
                            customClass: 'success'
                        });
                    })
                }
            },
            getTime(){
                this.$http({
                        url:"store-region-config",
                        method:"GET",
                        params:{
                            storeId:this.curStoreId,
                        }
                    }).then(res=>{
                        console.log(res);
                        this.voiceNotify = res.data.voiceNotify;
                        this.dateOpen = res.data.dateOpen;
                        if(res.data.message){
                            let message = res.data.message.split("**号机已下机");
                            if(message && Array.isArray(message) && message.length>1){
                                this.frontMessage = message[0];
                                this.backMessage = message[1];
                            }
                        }
                        if(res.data.minutes){
                            
                            let minutes = JSON.parse(res.data.minutes);
                            console.log(minutes);
                            let temp = [];
                            if(minutes && Array.isArray(minutes)){
                                minutes.forEach(it=>{
                                    temp.push({
                                        id:"",
                                        m:it
                                    })
                                })
                            }
                            this.timeArr = temp;
                        }
                    })
            },
            delTime(index){
                let timeArr = JSON.parse(JSON.stringify(this.timeArr));
                timeArr.splice(index,1);
                this.timeArr = timeArr;
            },
            delNotes(item){
                this.$http({
                    url:"delete-msg",
                    method:"POST",
                    data:{
                        id:item.id
                    }
                }).then(res=>{
                    console.log(res);
                    if(res.status == 200){
                        this.$message({
                            message: "删除成功",
                            customClass: 'success'
                        });
                        this.getNotesInfo();
                        return;
                    }
                });
            },
            saveNotes(item){
                let data;
                console.log(item.id)
                if(!item.message){
                   this.$message({
                        message: "请输入备注内容",
                        customClass: 'error'
                    }); 
                    return;
                }
                if(item.id!=""){
                    data = {
                        message:item.message,
                        id:item.id,
                        storeId:this.curStoreId
                    }
                }else{
                    data = {
                        message:item.message,
                        id:0,
                        storeId:this.curStoreId
                    }
                }
                
                this.$http({
                    url:"merge-msg",
                    method:"POST",
                    data
                }).then(res=>{
                    console.log(res);
                    if(res.status == 200){
                        this.$message({
                            message: "添加修改成功",
                            customClass: 'success'
                        });
                        this.getNotesInfo();
                    }
                });
            },
            savePrintEr(item){
                let data;
                console.log(item.id)
                if(item.id!=""){
                    data = {
                        port:item.port,
                        ipAddress:item.ipAddress,
                        name:item.name,
                        id:item.id,
                        storeId:this.curStoreId
                    }
                }else{
                    data = {
                        port:item.port,
                        ipAddress:item.ipAddress,
                        name:item.name,
                        id:0,
                        storeId:this.curStoreId
                    }
                }
                
                if(!this.checkPrintSet(item)){
                    return;
                }
                this.$http({
                    url:"merge-ip",
                    method:"POST",
                    data
                }).then(res=>{
                    console.log(res);
                    if(res.data.code == 200){
                        this.$message({
                            message: res.data.msg,
                            customClass: 'success'
                        });
                        this.getPrintIpInfo();
                        return;
                    }else{
                        this.$message({
                            message: res.data.msg,
                            customClass: 'error'
                        });
                        return;
                    }
                });
            },
            getPrintIpInfo(){
                this.$http({
                url:"ip-list",
                method:"GET",
                params:{
                    storeId:this.curStoreId
                    }
                }).then(res=>{
                    this.printEr = res.data;
                    console.log(res);
                });
            },
            getNotesInfo(){
                this.$http({
                url:"get-store-msg",
                method:"GET",
                params:{
                    storeId:this.curStoreId
                    }
                }).then(res=>{
                    this.notesArr = res.data;
                    console.log(res);
                });
            },
            checkPrintSet(item){
                let ipReg = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
                let portReg = /^\d{1,}$/;
                if(item.name.trim() == ""){
                    this.$message({
                        message: '请填写打印机名字',
                        customClass: 'error'
                    });
                    return false;
                }
                if(!ipReg.test(item.ipAddress)){
                    this.$message({
                        message: 'ip地址有误',
                        customClass: 'error'
                    });
                    return false;
                }
                if(!portReg.test(item.port)){
                    this.$message({
                        message: '端口填写错误',
                        customClass: 'error'
                    });
                    return false;
                }
                return true;
                
            },
            savePwd(){
                if(!this.discountPwd){
                    this.$message({
                        message: '请输入密码',
                        customClass: 'error'
                    })
                    return;
                }
                let pwd = new Base64();
                let pwdStr = 'hxbs 123.999'+ pwd.encode(this.discountPwd);
                this.$http({
                    url:"set-psw",
                    method:"POST",
                    data:{
                      storeId:this.curStoreId,
                      psw:pwdStr
                    }
                }).then(res=>{
                    if(res.data.code == 200){
                        this.$message({
                            message: res.data.msg,
                            customClass: 'success'
                        })
                    }
                });
            },
            saveLimit(){
                if(!/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(this.limitRechargeMoney)){
                    this.$message({
                        message: '价格格式有误',
                        customClass: 'error'
                    })
                    return;
                }
                this.$http({
                    url:"/update-recharge",
                    method:"POST",
                    data:{
                        storeId:this.curStoreId,
                        rechargeLimit:this.limitRechargeMoney
                    }
                }).then(res=>{
                    console.log(this.storeData);
                    this.$message({
                        message: '操作成功！',
                        customClass: 'success'
                    });
                    sessionStorage.setItem("rechargeLimit",JSON.stringify(this.limitRechargeMoney));
                });
            },
            configCoupon(){
                if(!this.curCouponData){
                  this.$message({
                        message: '请选择优惠券！',
                        customClass: 'error'
                    })
                    return;   
                }
                let body= {
                    storeId: this.curStoreId,
                    giveCouponId: this.curCouponData.id?this.curCouponData.id:''
                }
                this.$http.post('stores-config',body).then((res)=>{
                    this.$message({
                        message: '操作成功！',
                        customClass: 'success'
                    });
                })
            },
            getconfigCoupon(){
                this.$http.get('coupon/stores-config?storeId='+this.curStoreId).then((res)=>{
                    if(res.data&&res.data.couponId){
                        this.couponSwitch = "ON";
                        this.couponModel = res.data.title;
                        this.curCouponData.id =  res.data.couponId
                    }
                })
            },
            print: function () {
                this.curCouponPage++;
                this.sendCoupon();
            },
            sendCoupon(){
                 this.$http.get('coupon/list?storeId='+this.curStoreId+'&page='+this.curCouponPage+'&pageSize='+this.pageSize).then((res)=>{
                    this.couponList = this.couponList.concat(res.data.content);
                    if(res.data.content.length>=10){
                        this.couponListMoreBtn = true;
                    }else{
                        this.couponListMoreBtn = false;
                    }
                    this.couponBtn=true;
                    this.curCouponData={id:''};
                }).catch(()=>{

                })

            },
            //获取店主短信验证码
            getCode(){
                this.$http.post(this.curStoreId+'/verify-code').then((res)=>{
                    this.$message({
                        message: '发送成功！',
                        customClass: 'success'
                    })
                    this.isSendCodeBtn = false;
                    let timer;
                    timer = setInterval(()=>{
                        this.isSendCodeTimer--;
                        if(this.isSendCodeTimer==0){
                            clearInterval(timer);
                            this.isSendCodeTimer =59;
                            this.isSendCodeBtn = true;
                        }
                    },1000)
                }).catch(()=>{
                    this.initBtn4 = true;
                })
            },
            closeDialog(){
                this.code = '';
                this.payModeSwitch = 'THIRD_PARTY';
                this.isCancle = true;
            },
            codes(val){
                if(val=='CASHIER'){
                    this.codeBtn = true;
                }else if(val=="THIRD_PARTY"){
                    let body= {
                         payMode: 'THIRD_PARTY',
                         code: this.code
                    }
                    this.$http.put('stores/'+this.curStoreId+'/payMode-switch',body).then((res)=>{
                        this.isCASHIERBtn = false;
                    }).catch((err)=>{

                    })
                }
            },
            codeFn(){
                this.code = this.code.replace(/(^\s*)|(\s*$)/g, "");
                if(!/^\d{4}$/.test(this.code)){
                    this.$message({
                        message: '验证码格式有误！',
                        customClass: 'error'
                    })
                    return;
                }
                let body={
                    payMode: 'CASHIER',
                    code: this.code
                }
                this.$http.put('stores/'+this.curStoreId+'/payMode-switch',body).then((res)=>{
                    this.codeBtn = false;
                    this.isCASHIERBtn = true;
                }).catch((err)=>{
                })
            },
            // 保存修改店铺信息
            saveStore: function () {
                if ( !this.newStore.name ) {
                    this.$message({
                        message: '请输入店铺名',
                        customClass: 'error'
                    });
                    return;
                }
                if ( !this.newStore.addr ) {
                    this.$message({
                        message: '请输入店铺地址',
                        customClass: 'error'
                    });
                    return;
                };
                if ( !this.curStoreId ) {
                    this.curStoreId = this.$uuid.create(1).hex;
                };
                let curStore = {
                    "name": this.newStore.name , // 店铺名称
                    "typeId": this.newStore.typeId , // 店铺类型id
                    "addr": this.newStore.addr , // 店铺地址
                    "storeId":this.curStoreId
                    // "referralCode": this.newStore.referralCode  // 邀请码
                }
                //将code 转换成id
                for(let i = 0,len = this.storeType.length;i<len;i++){
                    if(curStore.typeId == this.storeType[i].code){
                        curStore.typeId = this.storeType[i].id
                    }
                }
                // this.$http.put('/stores/'+this.curStoreId, curStore).then((res)=>{
                //     this.$message({
                //         message: '操作成功！',
                //         customClass: 'success'
                //     });
                //     // this.newStore = {
                //     //     "name": res.data.name, // 店铺名称
                //     //     "typeId": res.data.typeCode, // 店铺类型id
                //     //     "addr": res.data.addr, // 店铺地址
                //     //     "referralCode": res.data.referralCode// 邀请码
                //     // }
                // }).catch((err) => {
                    
                // })
                this.$http.post('/update-store', curStore).then((res)=>{
                    this.$message({
                        message: res.data.result.msg,
                        customClass: 'success'
                    });
                    // this.newStore = {
                    //     "name": res.data.name, // 店铺名称
                    //     "typeId": res.data.typeCode, // 店铺类型id
                    //     "addr": res.data.addr, // 店铺地址
                    //     "referralCode": res.data.referralCode// 邀请码
                    // }
                }).catch((err) => {
                    
                })
            },
        },
        created: function () {
            this.$http.get('/store-types').then((res)=>{
                this.storeType = res.data;
                this.$http.get('/stores/'+this.curStoreId).then((res)=>{
                    this.newStore = {
                        "name": res.data.name, // 店铺名称
                        "typeId": res.data.typeCode, // 店铺类型id
                        "addr": res.data.addr, // 店铺地址
                        "referralCode": res.data.referralCode// 邀请码
                    }
                    this.returnCallEnabled = res.data.returnCallEnabled;
                    this.clerkCashSales =res.data.clerkCashSales?'ON':'OFF';
                    this.stockLimitSales=res.data.stockLimitSales?'ON':'OFF';
                    this.customSwitch = res.data.sysProductEnabled?'ON':'OFF';
                    this.isOpenPrevPrint = res.data.preEnabled?"ON":"OFF";
                    this.refundSwitch = res.data.refundPswEnabled?"ON":"OFF";
                    this.posCallEnabled = res.data.posCallEnabled ? "ON":"OFF"
                    // 
                    this.voiceEnabled = res.data.voiceEnabled?"ON":"OFF";
                    // this.autoPrintEnabled = res.data.autoPrintEnabled?"ON":"OFF";
                    this.pcOrderEnabled = res.data.pcOrderEnabled?"ON":"OFF";
                    // 
                    this.allowProductCancelSale = res.data.allowProductCancelSale;
                    this.deliveryEnabled = res.data.deliveryEnabled ? res.data.deliveryEnabled : false;
                    this.memberEnabled = res.data.memberEnabled ? res.data.memberEnabled : false;
                    this.globalRate = res.data.globalRate ? (res.data.globalRate * 100).toFixed(0) : 0;
                    // this.clerkMember = res.data.clerkMemberSwitch?'ON':'OFF';
                    if(res.data.payMode=='THIRD_PARTY'){
                        this.isCASHIERBtn = false;
                    }else if(res.data.payMode=='CASHIER'){
                        this.isCASHIERBtn = true;
                    }
                        this.logoUrl=res.data.storeLogo;
                        this.summary=res.data.summary;
                        this.hotTitle = res.data.title;
                        this.rollTitle = res.data.netTitle;
                        this.rollNotice = res.data.notice;
                        this.storeQrCode = res.data.storeCodeImage;
                })
            }).catch((err)=>{
                // console.log(err)
            });
            this.getconfigCoupon();
            this.sendCoupon();
             // 进入界面时请求店铺类型
           // this.getKitchenPsrint();
           let rechargeLimit = JSON.parse(sessionStorage.getItem("rechargeLimit"));
           this.limitRechargeMoney = rechargeLimit;
          
        },
        mounted: function () {
            this.getTime();
            // setTimeout(() => {
                this.getPrintIpInfo();
            // }, 300);
            this.getNotesInfo();
        }
    }
</script>
<style lang="scss">
    @import '../../../../static/css/common.scss';
    @import '../../tableTemplate/el-dialog.scss';
	@import "setting";
</style>



// WEBPACK FOOTER //
// setting.vue?8cef223a